import { render, staticRenderFns } from "./StatSectionLoader.vue?vue&type=template&id=43e464e9&"
import script from "./StatSectionLoader.vue?vue&type=script&lang=js&"
export * from "./StatSectionLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports